import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconStream = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <g>
            <path d="M25.5,1H4.5C2.5,1,1,2.5,1,4.5v21.1C1,27.5,2.5,29,4.5,29h21.1c1.9,0,3.5-1.6,3.5-3.5V4.5
				C29,2.5,27.5,1,25.5,1z M27.9,25.5c0,1.3-1,2.3-2.3,2.3H4.5c-1.3,0-2.3-1-2.3-2.3V4.5c0-1.3,1-2.3,2.3-2.3h21.1
				c1.3,0,2.3,1,2.3,2.3V25.5z M10.3,22.6L23.5,15L10.3,7.4V22.6z M11.5,9.4l9.7,5.6l-9.7,5.6V9.4z"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

IconStream.displayName = 'IconStream';
IconStream.muiName = 'SvgIcon';

export default IconStream;



// WEBPACK FOOTER //
// ./src/components/Icons/IconStream.js